/**
 * Fatiado de ReviewPanel.tsx (limite de linhas, QA 5640804090 r.3): o aviso
 * de chat do import — pergunta do assistente + respostas rápidas. Uma
 * resposta rápida que é CÓDIGO de idioma mostra o nome nativo e envia o
 * código como valor (#299 P6, revisão UX 5640787646).
 */
import type { ImportQuickReply } from '../../lib/api.js'

export function ReviewChatNudge({
  content,
  quickReplies,
  onSend,
  onAllOk,
}: {
  content: string
  quickReplies?: Array<string | ImportQuickReply> | undefined
  /** envia o texto/código como mensagem do dono */
  onSend: (text: string) => void
  /** ação do «tudo correto» */
  onAllOk: () => void
}) {
  return (
    <div className="rounded-2xl border border-amber-200 bg-amber-50 p-4 space-y-2">
      <p className="text-sm text-gray-800">💬 {content}</p>
      <div className="flex flex-wrap gap-2">
        {(quickReplies ?? []).map((qr, i) => {
          const q =
            typeof qr === 'string' ? ({ label: qr, action: 'reply' } as ImportQuickReply) : qr
          return (
            <button
              key={i}
              type="button"
              onClick={() => {
                if (q.action === 'all_ok') onAllOk()
                // {label, value} (pergunta de idioma): o botão mostra o nome
                // nativo e o VALOR (código) é o que vai como mensagem
                else if (q.action === 'reply') onSend(q.value ?? q.label)
                // dismiss: apenas fecha o aviso
              }}
              className="rounded-full border border-amber-300 bg-white text-gray-700 text-xs px-3 min-h-11 inline-flex items-center hover:bg-amber-100"
            >
              {q.label}
            </button>
          )
        })}
      </div>
    </div>
  )
}
